import jQuery from 'jquery';
import { get as getCookie } from 'js-cookie';

export default class BetslipInteractor {
    constructor() {
        this.setDecimalOddsSetting = this.setDecimalOddsSetting.bind(this);
        this.onBookmakerChanged = this.onBookmakerChanged.bind(this);
        this.onBetslipInitialized = this.onBetslipInitialized.bind(this);
        this.setBetslipBookmaker = this.setBetslipBookmaker.bind(this);
        this.init = this.init.bind(this);
    }

    init() {
        this.bindEvents();
        this.requestSelectedBookmaker();
        return new Promise((resolve) => {
            this.resolvePromise = resolve;
        });
    }

    onBookmakerChanged({ detail: { bookmaker } }) {
        jQuery(document).trigger('bookieChanged.BOOKMAKER', bookmaker);
        this.resolveBookmaker(bookmaker);
    }

    resolveBookmaker(bookmaker) {
        if (this.resolvePromise) {
            this.setDecimalOddsSetting();
            this.resolvePromise(bookmaker);
            this.resolvePromise = null;
        }
    }

    onBetslipInitialized() {
        this.requestSelectedBookmaker();
    }

    // eslint-disable-next-line class-methods-use-this
    requestSelectedBookmaker() {
        const betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.GET');
        document.dispatchEvent(betslipEvent);
    }

    // eslint-disable-next-line class-methods-use-this
    setBetslipBookmaker(bookmaker) {
        const betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.SET', {
            detail: { bookmaker },
        });
        document.dispatchEvent(betslipEvent);
    }

    bindEvents() {
        document.addEventListener('BETSLIP.BOOKMAKER_CHANGED', this.onBookmakerChanged, false);
        document.addEventListener('BETSLIP.BOOKMAKER', this.onBookmakerChanged, false);
        document.addEventListener('BETSLIP.INITIALIZED', this.onBetslipInitialized, false);
    }

    // eslint-disable-next-line class-methods-use-this
    setDecimalOddsSetting() {
        const customizeSettingsCookie = getCookie('customizeSettings');
        if (customizeSettingsCookie) {
            const customizeSettings = JSON.parse(customizeSettingsCookie);
            const betslipEvent = new CustomEvent('BETSLIP.SETTINGS_CHANGED', {
                detail: { useDecimalOdds: customizeSettings.decimalOdds },
            });
            document.dispatchEvent(betslipEvent);
        }
    }

    destroy() {
        document.removeEventListener('BETSLIP.BOOKMAKER_CHANGED', this.onBookmakerChanged, false);
        document.removeEventListener('BETSLIP.BOOKMAKER', this.onBookmakerChanged, false);
        document.removeEventListener('BETSLIP.INITIALIZED', this.onBetslipInitialized, false);
    }
}




// WEBPACK FOOTER //
// ./src/js/utils/BetslipInteractor.js